// extracted by mini-css-extract-plugin
module.exports = {"tcoButton":"ImnHw1"};